import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { auctionsParamsSchema } from 'src/pages/transport/auctions/tiles/schema';

export function useAuctionsPageParams() {
  return usePageParamsFromSchema(auctionsParamsSchema, {
    filters: {
      quickFilter: { label: 'Quick Filter' },
      quickFilterId: { label: 'Quick Filter' },
      networkPointOrBundleId: { label: 'Network Point' },
      direction: { label: 'Direction' },
      operatorId: { label: 'TSO' },
      capacityCategoryId: { label: 'Capacity Category' },
      marketableCapacityMin: { label: 'Marketable' },
      marketableCapacityMax: { label: 'Marketable' },
      runtimeIntersectionFilterStart: { label: 'Product Runtime' },
      runtimeIntersectionFilterEnd: { label: 'Product Runtime' },
      startingPriceMin: { label: 'Starting Price' },
      startingPriceMax: { label: 'Starting Price' },
      marketTransitionPriceMin: { label: 'Starting Price (In EUR/MWh)' },
      marketTransitionPriceMax: { label: 'Starting Price (In EUR/MWh)' },
      assignedAuctionId: { label: 'Auction ID' },
    },
  });
}

export type AuctionsPageParams = ReturnType<typeof useAuctionsPageParams>;
